export enum SolarProductType {
  TLS1_V1D = 0,
  TLS2_V2A = 1,
}
